module.exports = __webpack_public_path__ + "static/img/cbd-band-poster.9cd1b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/cbd-band-poster.jpg
// module id = 1ZAn
// module chunks = 1